import React, { useState } from "react";
import { Card, Button } from "react-bootstrap";
import SparePartsModal from "../../modals/SparePartsModal/SparePartsModal";
import "./SparePartsVehicleCard.css";

/**
 * SparePartsVehicleCard
 * Props:
 * - vehicle: object from vehiclesData.js
 */
export default function SparePartsVehicleCard({ vehicle }) {
  const [showModal, setShowModal] = useState(false);

  const hasSpareParts = (vehicle.spareParts || []).length > 0;

  return (
    <>
      <Card className="spare-parts-vehicle-card">
        {vehicle.imageSrc && (
          <Card.Img
            variant="top"
            src={vehicle.imageSrc}
            alt={vehicle.title}
            className="spare-parts-vehicle-card__image"
          />
        )}

        <Card.Body>
          <Card.Title className="spare-parts-vehicle-card__title">
            {vehicle.title}
          </Card.Title>

          <Button
            variant="link"
            className="spare-parts-vehicle-card__link lk-brand-link"
            onClick={() => setShowModal(true)}
            disabled={!hasSpareParts}
          >
            {hasSpareParts ? "Show Prices" : "Prices Not Available"}
          </Button>
        </Card.Body>
      </Card>

      {hasSpareParts && (
        <SparePartsModal
          show={showModal}
          onHide={() => setShowModal(false)}
          vehicle={vehicle}
        />
      )}
    </>
  );
}
